export default __webpack_public_path__ + "static/media/b69.fe03ad51.png";